import React, { useState } from "react";
import '../css/ModalHoraires.css'

const ModalHoraire = ({ horaires, setHoraires, onClose }) => {
  const [localHoraires, setLocalHoraires] = useState([...horaires]);

  const handleChange = (day, index, field, value) => {
    const updatedHoraires = [...localHoraires];
    const daySlots = updatedHoraires.filter((slot) => slot.jour === day);
    const slotIndex = localHoraires.indexOf(daySlots[index]);
    updatedHoraires[slotIndex][field] = value;
    setLocalHoraires(updatedHoraires);
  };

  const addTimeSlot = (day) => {
    setLocalHoraires([
      ...localHoraires,
      { jour: day, ouverture: "08:00:00+01", fermeture: "16:00:00+01" },
    ]);
  };

  const removeTimeSlot = (day, index) => {
    const updatedHoraires = localHoraires.filter((slot, i) => {
      const daySlots = localHoraires.filter((slot) => slot.jour === day);
      return !(i === localHoraires.indexOf(daySlots[index]));
    });
    setLocalHoraires(updatedHoraires);
  };

  const handleSave = () => {
    setHoraires(localHoraires);
    onClose();
  };

  const groupedByDay = Array.from({ length: 7 }, (_, day) =>
    localHoraires.filter((slot) => slot.jour === day)
  );
  const reorderedDays = [...groupedByDay.slice(1), groupedByDay[0]];

  return (
    <div className="modal-horaires">
      <div className="modal-horaires-content">
        <h2>Modifier les horaires d'ouverture</h2>
        <div className="modal-horaires-table">
          <table>
            <thead>
              <tr className="horaires_table_header">
                <th>Jour</th>
                <th colSpan={2}>Créneaux horaires</th>
                
              </tr>
            </thead>
            <tbody>
            

              {reorderedDays.map((slots, day) => (
                <tr key={day}>
                  <td>
                    {["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"][(day + 1) % 7]}
                  </td>
                  <td colSpan={2}>
                    {slots.map((slot, index) => (
                      <div key={index} className="time-slot">
                        <input
                          type="time"
                          value={slot.ouverture.split(":").slice(0, 2).join(":")}
                          onChange={(e) => handleChange((day + 1) % 7, index, "ouverture", `${e.target.value}:00+01`)}
                        />
                        <span>à</span>
                        <input
                          type="time"
                          value={slot.fermeture.split(":").slice(0, 2).join(":")}
                          onChange={(e) =>
                            handleChange((day + 1) % 7, index, "fermeture", `${e.target.value}:00+01`)
                          }
                        />
                        <button className="bouton_suppression_créneau"onClick={() => removeTimeSlot((day + 1) % 7, index)}>
                          <img
                          src="poubelle.png" className="poubelle" title="Supprimer ce créneau "/>
                        </button>
                      </div>
                    ))}
                    <button onClick={() => addTimeSlot((day + 1) % 7)} className="bouton_ajout_créneau">
                    <img
                          src="plus.png" className="plus" title="Ajouter un créneau "/>
                    </button>
                  </td>
                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="modal-horaires-actions">
          <button className="bouton_sauvegarde_horaires" onClick={handleSave}>
            <span style={{fontWeight : "bold"}}>Sauvegarder</span>
          </button>
          <button className = "bouton_sauvegarde_horaires" onClick={onClose}>
            <span style={{fontWeight : "bold"}}>Annuler</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalHoraire;
